export const DENVER_NEIGHBORHOODS = [
  "Downtown Denver", "LoDo", "RiNo", "Capitol Hill", "Cherry Creek",
  "Highlands", "Washington Park", "Park Hill", "Stapleton / Central Park",
  "Aurora", "Centennial", "Lakewood", "Littleton", "Englewood",
  "Greenwood Village", "Parker", "Castle Rock", "Highlands Ranch",
  "Wheat Ridge", "Arvada", "Westminster", "Thornton", "Broomfield",
  "Golden", "Commerce City", "Brighton",
];

export const DENVER_FAQS = [
  {
    q: "Do you service Denver from Colorado Springs?",
    a: "Yes — we're based in Colorado Springs and regularly run crews up I-25 into the Denver metro. Most Denver jobs get a same-week quote and can be scheduled within 7–14 days. Commercial jobs often start overnight for minimum disruption.",
  },
  {
    q: "How much does pressure washing cost in Denver?",
    a: "Residential Denver jobs typically range $150–$750 for driveways, decks, patios, house soft-washing. Commercial lots, fleet wash, and kitchen hoods range $300–$3,000+. Use the instant quote calculator for an exact range — Denver-area pricing is the same as Colorado Springs.",
  },
  {
    q: "Which Denver neighborhoods do you cover?",
    a: "We cover the entire Denver metro — LoDo, RiNo, Cherry Creek, Capitol Hill, Highlands, Wash Park, Park Hill, Aurora, Centennial, Lakewood, Littleton, Parker, Castle Rock, Highlands Ranch, Arvada, Westminster, Thornton, Broomfield, Golden, and surrounding. Call or text 719-644-6105 to confirm coverage for your address.",
  },
  {
    q: "Do you charge extra for travel from Colorado Springs to Denver?",
    a: "No fuel surcharge for quoted jobs in the Denver metro. We build routing into the quote. For larger commercial contracts we often schedule multi-site days to keep your costs down.",
  },
  {
    q: "Can you handle commercial lots, gas stations, or fleet washing in Denver?",
    a: "Yes. We regularly clean commercial lots, gas station pads, restaurant hoods (NFPA-96), fleets, and heavy equipment across the Denver metro. Monthly maintenance contracts available with volume discounts.",
  },
  {
    q: "Do you do house washing and gutter cleaning in Denver?",
    a: "Yes. Soft-wash siding cleaning (safe for stucco, LP SmartSide, brick, vinyl), gutter flush, window exterior cleaning, and deck/fence cleaning — all across the Denver metro.",
  },
  {
    q: "Are you licensed and insured to work in Denver and Arapahoe/Jefferson/Douglas counties?",
    a: "Yes. We are fully licensed and insured for both residential and commercial work across Denver, Arapahoe, Jefferson, Douglas, Adams, and Broomfield counties. A certificate of insurance (COI) is available on request for property managers, HOAs, and commercial clients.",
  },
  {
    q: "How soon can you schedule a Denver job?",
    a: "Most Denver residential quotes are scheduled within 7–14 days. Emergency commercial dispatch available within 24–48 hours for kitchen hood violations, health-inspector prep, or acute grime issues. Call or text 719-644-6105.",
  },
];

export const DENVER_HERO = {
  label: "DENVER, COLORADO",
  h1_pre: "Pressure Washing",
  h1_emphasis: "Denver trusts.",
  sub: "Heavy-duty residential & commercial pressure washing across the Denver metro — from LoDo storefronts to Littleton driveways, we bring the rig to you. Veteran owned. Fully insured. Same-week quotes.",
};
